import { I } from "@angular/cdk/keycodes";
import { DatePipe } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Chart } from "chart.js";

@Component({
  selector: "app-user-analytics",
  templateUrl: "./user-analytics.component.html",
  styleUrls: ["./user-analytics.component.scss"],
})
export class UserAnalyticsComponent implements OnInit {
  @ViewChild("flowChartCanvas", { static: true })
  flowChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundleChartCanvas", { static: true })
  bundleChartCanvas: ElementRef<HTMLCanvasElement>;

  @ViewChild("flowViewChartCanvas", { static: true })
  flowViewChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("flowLinkClickChartCanvas", { static: true })
  flowLinkClickChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundleViewChartCanvas", { static: true })
  bundleViewChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundleLinkClickChartCanvas", { static: true })
  bundleLinkClickChartCanvas: ElementRef<HTMLCanvasElement>;

  public lineFlowChartLabels: string[] = [];
  public lineFlowChartData: number[] = [];
  public lineFlowTitleChart: string[][] = []; // Parallel array to store userNames per date

  public lineFlowViewChartLabels: string[] = [];
  public lineFlowViewChartData: number[] = [];
  public lineFlowViewTitleChart: string[][] = []; // Parallel array to store userNames per date

  public lineFlowLinkClickChartLabels: string[] = [];
  public lineFlowLinkClickChartData: number[] = [];
  public lineFlowLinkClickTitleChart: string[][] = []; // Parallel array to store userNames per date

  public lineBundleChartLabels: string[] = [];
  public lineBundleChartData: number[] = [];
  public lineBundleTitleChart: string[][] = []; // Parallel array to store userNames per date

  public lineBundleViewChartLabels: string[] = [];
  public lineBundleViewChartData: number[] = [];
  public lineBundleViewTitleChart: string[][] = []; // Parallel array to store userNames per date

  public lineBundleLinkClickChartLabels: string[] = [];
  public lineBundleLinkClickChartData: number[] = [];
  public lineBundleLinkClickTitleChart: string[][] = []; // Parallel array to store userNames per date
  selectedTimePeriod: "daily" | "weekly" | "monthly" | "year" = "year"; // Default to weekly

  userData: any;
  userAnalyticsData: any;
  contentOfUser: any;
  flowsList: any = [];
  bundlesList: any = [];
  noResultReturned: boolean = false;

  constructor(public dialogRef: MatDialogRef<UserAnalyticsComponent>) {}
  ngOnInit(): void {
    this.userAnalyticsData = JSON.parse(localStorage.getItem("userAnalytics"));
    if (this.userAnalyticsData) {
      this.processData();
    }
    this.contentOfUser = this.userAnalyticsData.userContentDetailsModels;
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
  }

  onTimePeriodChange() {
    this.processData();
  }
  processData() {
    // Iterate through userModelDetailList
    this.userAnalyticsData.userContentDetailsModels.forEach((content) => {
      content.userName = this.userAnalyticsData.userName;
      if (content.flowType === "Flow") {
        this.flowsList.push(content);
      } else if (content.flowType === "Bundle") {
        this.bundlesList.push(content);
      }
    });

    this.resetAnalytivs();
  }

  private resetAnalytivs() {
    this.initializeChartDataOnly();
    this.flowChartData();
    this.flowViewChartData();
    this.flowLinkClickChartData();
    this.bundleChartData();
    this.bundleViewChartData();
    this.bundleLinkClickChartData();
  }

  initializeChartDataOnly(): void {
    this.lineFlowChartData = [];
    this.lineFlowViewChartData = [];
    this.lineFlowLinkClickChartData = [];
    this.lineBundleChartData = [];
    this.lineBundleViewChartData = [];
    this.lineBundleLinkClickChartData = [];
  }

  close() {
    localStorage.setItem("userAnalytics", null);
    this.dialogRef.close();
  }
  flowChartData() {
    this.extractFlowDateRange();
    // this.updateFlowChartData();
    this.destroyFlowChart(this.flowChartCanvas);
    this.initLineFlowChart();
  }

  flowViewChartData() {
    this.extractFlowViewDateRange();
    // this.updateFlowViewChartData();
    this.destroyFlowViewChart(this.flowViewChartCanvas);
    this.initLineFlowViewChart();
  }
  flowLinkClickChartData() {
    this.extractFlowLinkClickDateRange();
    // this.updateFlowLinkClickChartData();
    this.destroyFlowLinkClickChart(this.flowLinkClickChartCanvas);
    this.initLineFlowLinkClickChart();
  }
  bundleChartData() {
    this.extractBundleDateRange();
    // this.updateBundleChartData();
    this.destroyBundleChart(this.bundleChartCanvas);
    this.initLineBundleChart();
  }
  bundleViewChartData() {
    this.extractBundleViewsDateRange();
    // this.updateBundleViewsChartData();
    this.destroyBundleViewsChart(this.bundleViewChartCanvas);
    this.initLineBundleViewsChart();
  }
  bundleLinkClickChartData() {
    this.extractBundleLinkClickDateRange();
    // this.updateBundleLinkClickChartData();
    this.destroyBundleLinkClickChart(this.bundleLinkClickChartCanvas);
    this.initLineBundleLinkClickChart();
  }
  //Flow over time

  destroyFlowChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineFlowChart() {
    const flowChartCtx = this.flowChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(flowChartCtx, {
      type: "line",
      data: {
        labels: this.lineFlowChartLabels,
        datasets: [
          {
            data: this.lineFlowChartData,
            label: "Flows Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineFlowChartData[index];
                const users =
                  this.lineFlowTitleChart[index]?.join(", ") || "No title";
                return `Flow Titles: ${count}\nFlows: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateFlowChartData() {
    this.lineFlowChartData = [];
    this.lineFlowTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; flowName: Set<string> }
    >();

    this.flowsList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = element.flowName;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            flowName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += 1;
        if (userName) {
          entry.flowName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineFlowChartData.push(entry.count);
        this.lineFlowTitleChart.push(Array.from(entry.flowName)); // Store associated usernames
      }
    });
  }

  extractFlowDateRange() {
    if (!this.flowsList || this.flowsList.length === 0) return;
    this.lineFlowChartLabels = [];
    this.lineFlowTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.flowsList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + 1);
      this.lineFlowTitleChart.push(Array.from(item.flowName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineFlowChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowChartData = sortedEntries.map(([_, value]) => value);
  }

  //Bundle over time

  destroyBundleChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineBundleChart() {
    const lineChartCtx = this.bundleChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.lineBundleChartLabels,
        datasets: [
          {
            data: this.lineBundleChartData,
            label: "Bundles Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineBundleChartData[index];
                const users =
                  this.lineBundleTitleChart[index]?.join(", ") || "No bundles";
                return `Bundles: ${count}\nBundles: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateBundleChartData() {
    this.lineBundleChartData = [];
    this.lineBundleTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; bundleName: Set<string> }
    >();

    this.bundlesList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = `${element.flowName}- ${element.userName}`;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            bundleName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += 1;
        if (userName) {
          entry.bundleName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineBundleChartData.push(entry.count);
        this.lineBundleTitleChart.push(Array.from(entry.bundleName)); // Store associated usernames
      }
    });
  }
  extractBundleDateRange() {
    if (!this.bundlesList || this.bundlesList.length === 0) return;
    this.lineBundleChartLabels = [];
    this.lineBundleTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.bundlesList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + 1);
      const userName = `${item.flowName}- ${item.userName}`;
      if (userName) this.lineBundleTitleChart.push(Array.from(userName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineBundleChartLabels = sortedEntries.map(([label]) => label);
    this.lineBundleChartData = sortedEntries.map(([_, value]) => value);
  }

  //Bundle Views over time
  destroyBundleViewsChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineBundleViewsChart() {
    const lineChartCtx =
      this.bundleViewChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.lineBundleViewChartLabels,
        datasets: [
          {
            data: this.lineBundleViewChartData,
            label: "Bundle Views Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineBundleViewChartData[index];
                const users =
                  this.lineBundleViewTitleChart[index]?.join(", ") ||
                  "No bundles";
                return `Bundle Views : ${count}\nBundles: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateBundleViewsChartData() {
    this.lineBundleViewChartData = [];
    this.lineBundleViewTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; bundleName: Set<string> }
    >();

    this.bundlesList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = `${element.flowName}- ${element.userName}`;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            bundleName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += element.viewCount;
        if (userName) {
          entry.bundleName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineBundleViewChartData.push(entry.count);
        this.lineBundleViewTitleChart.push(Array.from(entry.bundleName)); // Store associated usernames
      }
    });
  }

  extractBundleViewsDateRange() {
    if (!this.bundlesList || this.bundlesList.length === 0) return;
    this.lineBundleViewChartLabels = [];
    this.lineBundleViewTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.bundlesList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + (item.linkClicks ?? 0));
      const userName = `${item.flowName}- ${item.userName}`;
      if (userName) this.lineBundleViewTitleChart.push(Array.from(userName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineBundleViewChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowLinkClickChartData = sortedEntries.map(([_, value]) => value);
  }

  //Flow Views over time

  destroyFlowViewChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineFlowViewChart() {
    const flowChartCtx =
      this.flowViewChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(flowChartCtx, {
      type: "line",
      data: {
        labels: this.lineFlowViewChartLabels,
        datasets: [
          {
            data: this.lineFlowViewChartData,
            label: "Flow Views Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineFlowViewChartData[index];
                const users =
                  this.lineFlowViewTitleChart[index]?.join(", ") || "No title";
                return `Flow Views: ${count}\nFlows: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateFlowViewChartData() {
    this.lineFlowViewChartData = [];
    this.lineFlowViewTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; flowName: Set<string> }
    >();

    this.flowsList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = element.flowName;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            flowName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += element.viewCount;
        if (userName) {
          entry.flowName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineFlowViewChartData.push(entry.count);
      }
    });
  }
  extractFlowViewDateRange() {
    if (!this.flowsList || this.flowsList.length === 0) return;
    this.lineFlowViewChartData = [];
    this.lineFlowViewTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.flowsList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.viewCount);
      this.lineFlowViewTitleChart.push(Array.from(item.flowName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineFlowViewChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowViewChartData = sortedEntries.map(([_, value]) => value);
  }

  //Bundle LinkClick over time
  destroyBundleLinkClickChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineBundleLinkClickChart() {
    const lineChartCtx =
      this.bundleLinkClickChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.lineBundleLinkClickChartLabels,
        datasets: [
          {
            data: this.lineBundleLinkClickChartData,
            label: "Bundle Link Clicks Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineBundleLinkClickChartData[index];
                const users =
                  this.lineBundleLinkClickTitleChart[index]?.join(", ") ||
                  "No bundles";
                return `Bundle Link Clicks Count : ${count}\nBundles: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateBundleLinkClickChartData() {
    this.lineBundleLinkClickChartData = [];
    this.lineBundleLinkClickTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; bundleName: Set<string> }
    >();

    this.bundlesList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = `${element.flowName}- ${element.userName}`;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            bundleName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += element.linkClicks ?? 0;
        if (userName) {
          entry.bundleName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineBundleLinkClickChartData.push(entry.count);
        this.lineBundleLinkClickTitleChart.push(Array.from(entry.bundleName)); // Store associated usernames
      }
    });
  }
  extractBundleLinkClickDateRange() {
    if (!this.bundlesList || this.bundlesList.length === 0) return;
    this.lineBundleLinkClickChartLabels = [];
    this.lineBundleLinkClickTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.bundlesList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + (item.linkClicks ?? 0));
      const userName = `${item.flowName}- ${item.userName}`;
      if (userName)
        this.lineBundleLinkClickTitleChart.push(Array.from(userName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineBundleLinkClickChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowLinkClickChartData = sortedEntries.map(([_, value]) => value);
  }

  //Flow LinkClick over time

  destroyFlowLinkClickChart(canvas: ElementRef<HTMLCanvasElement>) {
    const ctx = canvas.nativeElement.getContext("2d");
    Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
  }

  initLineFlowLinkClickChart() {
    const flowChartCtx =
      this.flowLinkClickChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(flowChartCtx, {
      type: "line",
      data: {
        labels: this.lineFlowLinkClickChartLabels,
        datasets: [
          {
            data: this.lineFlowLinkClickChartData,
            label: "Flow Link Clicks Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const index = context.dataIndex;
                const count = this.lineFlowLinkClickChartData[index];
                const users =
                  this.lineFlowLinkClickTitleChart[index]?.join(", ") ||
                  "No title";
                return `Flow LinkClick Count: ${count}\nFlows: ${users}`;
              },
            },
          },
        },
        scales: {
          y: {
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    });
  }

  private updateFlowLinkClickChartData() {
    this.lineFlowLinkClickChartData = [];
    this.lineFlowLinkClickTitleChart = [];
    const datePipe = new DatePipe("en-US");

    const dateDataMap = new Map<
      string,
      { count: number; flowName: Set<string> }
    >();

    this.flowsList.forEach((element) => {
      const formattedDate = datePipe.transform(element.timestamp, "dd/MM/yy");
      const userName = element.flowName;
      if (formattedDate) {
        if (!dateDataMap.has(formattedDate)) {
          dateDataMap.set(formattedDate, {
            count: 0,
            flowName: new Set<string>(),
          });
        }
        const entry = dateDataMap.get(formattedDate)!;
        entry.count += element.linkClicks ?? 0;
        if (userName) {
          entry.flowName.add(userName);
        }
      }
    });

    const sortedDates = Array.from(dateDataMap.keys()).sort((a, b) => {
      const dateA = new Date(a.split("/").reverse().join("/"));
      const dateB = new Date(b.split("/").reverse().join("/"));
      return dateA.getTime() - dateB.getTime();
    });

    sortedDates.forEach((date) => {
      const entry = dateDataMap.get(date);
      if (entry) {
        this.lineFlowLinkClickChartData.push(entry.count);
        this.lineFlowLinkClickTitleChart.push(Array.from(entry.flowName)); // Store associated usernames
      }
    });
  }

  extractFlowLinkClickDateRange() {
    if (!this.flowsList || this.flowsList.length === 0) return;
    this.lineFlowLinkClickChartLabels = [];
    this.lineFlowLinkClickTitleChart = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.flowsList.forEach((item) => {
      const date = new Date(item.timestamp);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + (item.linkClicks ?? 0));
      this.lineFlowLinkClickTitleChart.push(Array.from(item.flowName)); // Store associated usernames
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineFlowLinkClickChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowLinkClickChartData = sortedEntries.map(([_, value]) => value);
  }
}
